import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'
import { languages } from '../../i18n/languages';
export default function FlagButton({ language }) {
  const { i18n } = useTranslation();
  const label = languages[language].label;
  const flagSrc = languages[language].flagSrc;
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = 64;
    canvas.height = 48;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = false
    const img = new Image();
    img.onload = () => {
      // Calcular proporções para "cover"
      const imgRatio = img.width / img.height;
      const canvasRatio = canvas.width / canvas.height;
      let drawWidth, drawHeight, offsetX, offsetY;

      if (imgRatio > canvasRatio) {
        drawHeight = canvas.height;
        drawWidth = drawHeight * imgRatio;
        offsetX = (canvas.width - drawWidth) / 2;
        offsetY = 0;
      } else {
        drawWidth = canvas.width;
        drawHeight = drawWidth / imgRatio;
        offsetX = 0;
        offsetY = (canvas.height - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
    };
    img.src = flagSrc;
  }, [flagSrc]);

  return (
    <button className={`language-button ${i18n.language === language ? 'active' : ''}`} onClick={() => i18n.changeLanguage(language)} aria-label={label} title={label}>
      <canvas ref={canvasRef} width="64" height="48" alt={label} />
    </button>
  );
}
